/* eslint-disable max-classes-per-file */
import { imageFallback } from "@/utils/error/imageError";

interface ImageSet {
  // people: string;
  // circle: string;
  // bg: string;
  // bgMix: string;
  // bgColor: string;
  people?: string;
  bg?: string;
}

export interface ColorTheme {
  lighter?: string;
  light?: string;
  base?: string;
  dark?: string;
}

export interface LandingTheme {
  circle?: string;
  bgColor?: string;
  textColorButton: string;
}

export interface Gradient {
  start: string;
  end: string;
}

export interface Theme {
  desktop?: ImageSet;
  mobile?: ImageSet;
  color?: ColorTheme;
  gradient?: Gradient | null;
  landing?: {
    desktop?: LandingTheme;
    mobile?: LandingTheme;
  };
}

export class KlubOtherDetail {
  klubId: number;

  name: string;

  title?: string;

  slug: string;

  icon: string;

  description?: string;

  desktop: ImageSet;

  mobile: ImageSet;

  theme: Theme;

  isFavourite: boolean;

  constructor(data: any) {
    this.klubId = data.klubId || 0;
    this.name = data.name || "";
    this.title = data.title || "";
    this.slug = data.slug || "";
    this.icon = data.icon || "";
    this.description = data.description || "";
    this.desktop = {
      people: data.theme?.desktop?.people || "",
      bg: data.theme?.desktop?.bg || "",
    };

    this.mobile = {
      people: data.theme?.mobile?.people || "",
      bg: data.theme?.mobile?.bg || "",
    };

    this.theme = {
      desktop: {
        people: data.theme?.desktop?.people || "",
        bg: data.theme?.desktop?.bg || "",
      },
      mobile: {
        people: data.theme?.mobile?.people || "",
        bg: data.theme?.mobile?.bg || "",
      },
      color: {
        lighter: data.theme?.color?.lighter,
        light: data.theme?.color?.light,
        base: data.theme?.color?.base,
        dark: data.theme?.color?.dark,
      },
      gradient: data.theme?.gradient ?? null,
      landing: {
        desktop: {
          circle: data.theme?.landing?.desktop?.circle || "",
          bgColor: data.theme?.landing?.desktop?.bgColor || "",
          textColorButton: data.theme?.landing?.desktop?.textColorButton || "",
        },
        mobile: {
          circle: data.theme?.landing?.mobile?.circle || "",
          bgColor: data.theme?.landing?.mobile?.bgColor || "",
          textColorButton: data.theme?.landing?.mobile?.textColorButton || "",
        },
      },
    };
    this.isFavourite = data.isFavourite || false;
  }
}

export class KlubExclusive {
  klubId: number;

  klubSlug: string;

  icon: string;

  themeColor: {
    lighter: string;
    light: string;
    base: string;
    dark: string;
  };

  tabMenu: {
    text: string;
    textColor: string;
  };

  backgroundImage: {
    desktop: {
      shape: string;
      vector: string;
      vector2: string;
    };
    mobile: {
      shape: string;
      vector: string;
    };
  };

  klub: {
    title: string;
    description: {
      desktop: string;
      mobile: string;
    };
    route: string;
    infoTextColor: string;
    textColorButton: string;
  };

  exclusiveBanner: {
    title: string;
    description: string;
    route: string;
    image: {
      background: string;
      people: string;
      shape: string;
      shapeMobile: string;
    };
    color: string;
    buttonColor: {
      text: string;
      bg: string;
    };
  };

  image: string;

  quota: {
    icon: string;
    message: string;
    location: string;
    date?: string | null;
    rating?: number | null;
    review?: number | null;
  };

  media: {
    type: string;
    caption: string;
    url: string;
    coverImage: string;
  };

  slug: string;

  citySlug: string;

  countrySlug: string;

  experienceId: number;

  price: number;

  currency: string;

  constructor(data: any) {
    this.klubId = data.klubId || 0;
    this.klubSlug = data.klubSlug || "";

    this.icon = data.icon || "";
    this.themeColor = {
      lighter: data.themeColor?.lighter || "#F0F0F0",
      light: data.themeColor?.light || "#D0D0D0",
      base: data.themeColor?.base || "#B0B0B0",
      dark: data.themeColor?.dark || "#909090",
    };

    this.tabMenu = {
      text: data.tabMenu?.text || "",
      textColor: data.tabMenu?.textColor || "",
    };

    this.backgroundImage = {
      desktop: {
        shape: data.backgroundImage?.desktop?.shape || "",
        vector: data.backgroundImage?.desktop?.vector || "",
        vector2: data.backgroundImage?.desktop?.vector2 || "",
      },
      mobile: {
        shape: data.backgroundImage?.mobile?.shape || "",
        vector: data.backgroundImage?.mobile?.vector || "",
      },
    };

    this.klub = {
      title: data.klub?.title || "",
      description: {
        desktop: data.klub?.description?.desktop || "",
        mobile: data.klub?.description?.mobile || "",
      },
      route: data.klub?.route || "",
      infoTextColor: data.klub?.infoTextColor || "#000000",
      textColorButton: data.klub?.textColorButton || "#FFFFFF",
    };

    this.exclusiveBanner = {
      title: data.exclusiveBanner?.title || "",
      description: data.exclusiveBanner?.description || "",
      route: data.exclusiveBanner?.route || "",
      image: {
        background: data.exclusiveBanner?.image?.background || "",
        people: data.exclusiveBanner?.image?.people || "",
        shape: data.exclusiveBanner?.image?.shape || "",
        shapeMobile: data.exclusiveBanner?.image?.shapeMobile || "",
      },
      buttonColor: {
        text: data.exclusiveBanner?.buttonColor?.text || "#000000",
        bg: data.exclusiveBanner?.buttonColor?.bg || "#FFFFFF",
      },
      color: data.exclusiveBanner?.color || "#FFFFFF",
    };

    this.image = data.image || imageFallback;

    this.quota = {
      icon: data.quota?.icon || "",
      message: data.quota?.message || "",
      location: data.quota?.location || "",
      date: data.quota?.date || "",
      rating: data.quota?.rating || "",
      review: data.quota?.review || "",
    };

    this.media = {
      type: data.media?.type || "",
      caption: data.media?.caption || "",
      url: data.media?.url || "",
      coverImage: data.media?.coverImage || "",
    };

    this.slug = data.slug || "";
    this.citySlug = data.citySlug || "";
    this.countrySlug = data.countrySlug || "";
    this.experienceId = data.experienceId || 0;
    this.price = data.price || 0;
    this.currency = data.currency || "";
  }
}

export class ResponseKlubLifeStyleAndKlubExclusive {
  klub: KlubOtherDetail[];

  klubExclusive: KlubExclusive[];

  constructor(data: any) {
    this.klub = Array.isArray(data.klub)
      ? data.klub.map((item: any) => new KlubOtherDetail(item))
      : [];

    this.klubExclusive = Array.isArray(data.klubExclusive)
      ? data.klubExclusive.map((item: any) => new KlubExclusive(item))
      : [];
  }
}
